(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["borojo-product-lp"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';
      const menu = root.querySelector('[data-bj-menu]');
      if (menu) {
        const menuToggle = menu.querySelector('summary');
        menu.addEventListener('toggle', () => menuToggle.setAttribute('aria-expanded', String(menu.open)));
        menu.addEventListener('click', event => {
          const link = event.target.closest('a');
          if (!link) return;
          menu.open = false;
          if (link.hash) {
            const target = root.querySelector(link.hash);
            if (target) { target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true }); }
          }
        });
        root.addEventListener('keydown', event => {
          if (event.key === 'Escape' && menu.open) { menu.open = false; menu.querySelector('summary').focus(); }
        });
        root.addEventListener('click', event => { if (menu.open && !menu.contains(event.target)) menu.open = false; });
      }
      const form = root.querySelector('.bj-product-form');
      const buttons = Array.from(root.querySelectorAll('[data-buy]'));
      const feedback = root.querySelector('[data-cart-feedback]');
      const status = root.querySelector('[data-cart-status]');
      const cartLink = root.querySelector('[data-cart-link]');
      const mobile = root.querySelector('[data-mobile-buy]');
      
      let busy = false;
      const quantity = form.querySelector('[data-quantity-input]');
      const quantityControls = Array.from(form.querySelectorAll('[data-quantity-step]'));
      const updateQuantityControls = () => {
        const value = quantity.valueAsNumber;
        const minimum = Number(quantity.min) || 1;
        quantity.readOnly = busy;
        quantityControls.forEach(control => {
          const decrement = control.dataset.quantityStep === '-1';
          const atMinimum = !Number.isFinite(value) || value <= minimum;
          const atMaximum = quantity.max !== '' && value >= Number(quantity.max);
          control.disabled = busy || (decrement ? atMinimum : atMaximum);
        });
      };
      quantityControls.forEach(control => control.addEventListener('click', () => {
        if (busy) return;
        const direction = Number(control.dataset.quantityStep);
        if (!Number.isFinite(quantity.valueAsNumber)) quantity.value = quantity.min || '1';
        else if (direction < 0) quantity.stepDown();
        else quantity.stepUp();
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      quantity.addEventListener('input', updateQuantityControls);
      quantity.addEventListener('change', updateQuantityControls);
      const setButtons = () => {
        buttons.forEach(button => {
        button.disabled = busy || root.dataset.purchasable !== 'true';
        button.setAttribute('aria-busy', String(busy));
        button.querySelector('[data-buy-label]').textContent = busy ? root.dataset.cartBusy : (root.dataset.purchasable === 'true' ? root.dataset.buyText : root.dataset.soldOut);
        });
        updateQuantityControls();
      };
      setButtons();
      const closeFeedback = () => { feedback.hidden = true; };
      root.querySelector('[data-close-feedback]').addEventListener('click', closeFeedback);
      root.addEventListener('keydown', event => { if (event.key === 'Escape' && !feedback.hidden) closeFeedback(); });
      root.querySelector('[data-variant-select]')?.addEventListener('change', (event) => {
        const option = event.target.selectedOptions[0];
        root.dataset.purchasable = option.dataset.available;
        root.querySelectorAll('[data-product-price]').forEach(item => { item.textContent = option.dataset.price; });
        root.querySelectorAll('[data-serving-price]:not(option)').forEach(item => { item.textContent = option.dataset.servingPrice; });
        setButtons();
      });
      if (mobile && 'IntersectionObserver' in window) {
        const hero = root.querySelector('.bj-hero');
        const purchase = root.querySelector('.bj-product-form');
        const final = root.querySelector('.bj-final');
        const visible = new Map();
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => visible.set(entry.target, entry.isIntersecting));
          mobile.hidden = !!visible.get(hero) || !!visible.get(purchase) || !!visible.get(final);
        }, { threshold: 0 });
        [hero, purchase, final].forEach(element => observer.observe(element));
        root._borojoObserver = observer;
      }
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || root.dataset.purchasable !== 'true') return;
        busy = true;
        setButtons();
        feedback.hidden = false;
        feedback.classList.remove('is-error');
        status.textContent = root.dataset.cartBusy;
        cartLink.hidden = true;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 20000);
        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            signal: controller.signal,
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form)
          });
          let result;
          try { result = await response.json(); } catch { throw new TypeError('Unconfirmed cart response'); }
          if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : root.dataset.cartError);
          status.textContent = root.dataset.cartSuccess;
          cartLink.hidden = false;
          if (!feedback.hidden) cartLink.focus({ preventScroll: true });
          document.dispatchEvent(new CustomEvent('borojo:cart-added', { detail: result }));
        } catch (error) {
          feedback.classList.add('is-error');
          status.textContent = error instanceof TypeError || error.name === 'AbortError' ? root.dataset.networkError : (error.message || root.dataset.cartError);
          cartLink.hidden = false;
        } finally {
          clearTimeout(timeout);
          busy = false;
          setButtons();
        }
      });
    };
    const initializeAll = () => document.querySelectorAll('[data-borojo-lp]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    else initializeAll();
    document.addEventListener('shopify:section:load', event => initialize(event.target.querySelector('[data-borojo-lp]')));
    document.addEventListener('shopify:section:unload', event => event.target.querySelector('[data-borojo-lp]')?._borojoObserver?.disconnect());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
